import { apiClient } from "./httpClient";
import { unwrapEnvelope } from "./response";

export const rbacApi = {
  async listRolePermissions() {
    const response = await apiClient.get("/rbac/roles");
    return unwrapEnvelope(response.data, { roles: [], permissions: [], defaults: {} });
  },

  async updateRolePermissions(roleId, permissions) {
    const response = await apiClient.put(`/rbac/roles/${roleId}/permissions`, { permissions });
    return unwrapEnvelope(response.data, null);
  },

  async validateRolePermissions(roleId, permissions) {
    const response = await apiClient.post(`/rbac/roles/${roleId}/validate`, { permissions });
    return unwrapEnvelope(response.data, null);
  },

  async previewRolePermissions(roleId, permissions) {
    const response = await apiClient.post(`/rbac/roles/${roleId}/preview`, { permissions });
    return unwrapEnvelope(response.data, null);
  },

  async resetRolePermissions(roleId) {
    const response = await apiClient.post(`/rbac/roles/${roleId}/reset`);
    return unwrapEnvelope(response.data, null);
  },

  async listAuditLog(params = {}) {
    const response = await apiClient.get("/rbac/audit-log", { params });
    return unwrapEnvelope(response.data, []);
  }
};
